import store from "@/CommonDP/store"

// 这个由项目代码处理

export default store;
